<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <v-tabs>
                    <v-tab @change="getDocumentApprovals">Documents</v-tab>
                    <v-tab-item>
                        <v-row class="mt-2 mb-2" align="center" justify="end">
                            <v-col md="2">
                                <responsiveButton
                                    :setText="true"
                                    setColor="orange"
                                    setDefaultIcon="mdi-refresh"
                                    setSmallIcon="mdi-refresh"
                                    :setClick="refreshDocumentApprovals"
                                ></responsiveButton>
                            </v-col>
                            <v-col md="2">
                                <v-select
                                    item-text="name"
                                    item-value="value"
                                    :items="status"
                                    label="Filter By Status"
                                    v-model="documentsSelect"
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-data-table
                            :headers="documentsTable.headers"
                            :items="documentApprovals"
                            :loading="loading"
                            loading-text="Loading... Please wait"
                            class="elevation-1"
                            :options.sync="documentPagination"
                            :server-items-length="totalDocumentItems"
                        >
                            <template v-slot:item.status="{ item }">
                                <v-chip
                                    :color="APPROVAL_STATUS[item.status].color"
                                    dark
                                >{{ item.status ? item.status : 'Pending' }}</v-chip>
                            </template>

                            <template v-slot:item.systemCreatedDateTime="{ item }">
                                <div>{{ item.systemCreatedDateTime | formatDate }}</div>
                            </template>

                            <!-- actions -->
                            <template v-slot:item.review="{ item }">
                                <v-icon
                                    class="mr-2"
                                    @click="editApproval(item)"
                                    v-if="item.status === 'PENDING'"
                                >fa-file-signature</v-icon>
                                <v-icon class="mr-2" @click="editApproval(item)" v-else>mdi-eye</v-icon>
                            </template>
                        </v-data-table>
                    </v-tab-item>

                    <v-tab @change="getReportApprovals">Reports</v-tab>
                    <v-tab-item>
                        <v-row class="mt-2 mb-2" align="center" justify="end">
                            <v-col md="2">
                                <responsiveButton
                                    :setText="true"
                                    setColor="orange"
                                    setDefaultIcon="mdi-refresh"
                                    setSmallIcon="mdi-refresh"
                                    :setClick="refreshReportApprovals"
                                ></responsiveButton>
                            </v-col>
                            <v-col md="2">
                                <v-select
                                    item-text="name"
                                    item-value="value"
                                    :items="status"
                                    label="Filter By Status"
                                    v-model="reportsSelect"
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-data-table
                            :headers="reportsTable.headers"
                            :items="reportApprovals"
                            :loading="loading"
                            loading-text="Loading... Please wait"
                            class="elevation-1"
                            :options.sync="reportPagination"
                            :server-items-length="totalReportItems"
                        >
                            <template v-slot:item.status="{ item }">
                                <v-chip
                                    :color="APPROVAL_STATUS[item.status].color"
                                    dark
                                >{{ item.status ? item.status : 'Pending' }}</v-chip>
                            </template>

                            <template v-slot:item.systemCreatedDateTime="{ item }">
                                <div>{{ item.systemCreatedDateTime | formatDate }}</div>
                            </template>

                            <!-- actions -->
                            <template v-slot:item.review="{ item }">
                                <v-icon class="mr-2" @click="editApproval(item)">fa-file-signature</v-icon>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs>

                <!-- Edit Approval Dialog -->
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-dialog v-model="dialog" persistent max-width="500px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Review Request</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row align="center" justify="center">
                                        <v-col>
                                            <v-label>Requested by:</v-label>
                                        </v-col>
                                        <v-col>{{editedItem.reviewByEmail}}</v-col>
                                    </v-row>
                                    <hr />
                                    <v-row align="center" justify="center">
                                        <v-col>
                                            <file-download
                                                :setDisabled="editedItem.documentFile === 'NONE'"
                                                :belongUserId="editedItem.documentFile.belongUser"
                                                :setIcon="true"
                                                :name="editedItem.documentFile.name"
                                            />
                                        </v-col>
                                    </v-row>
                                    <hr />
                                    <v-row align="center" justify="center" v-if="this.editedItem.status === 'PENDING'">

                                        <v-radio-group
                                            v-model="formValues.approved"
                                            :rules="[v => !(v === null) || 'Approve or Reject the request']"
                                            required
                                            row
                                            :readonly="formValues.readOnly"
                                        >
                                            <v-radio label="Approve" v-bind:value="true"></v-radio>
                                            <v-radio label="Reject" v-bind:value="false"></v-radio>
                                        </v-radio-group>
                                    </v-row>
                                    <v-row align="center" justify="center" v-else>
                                        <v-col cols="4">
                                            <h3>Status:</h3>
                                        </v-col>
                                        <v-col cols="8">
                                            <h4>{{this.editedItem.status}}</h4>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        align="center"
                                        justify="center"
                                        v-if="formValues.approved != null && !formValues.approved"
                                    >
                                        <v-col>
                                            <v-textarea
                                                placeholder="Enter a reason why you are rejecting this request."
                                                v-model="formValues.comment"
                                                label="Comments"
                                                :rules="[v => !!v || 'A reason is required when approval is denied']"
                                                :counter="255"
                                                :readonly="formValues.readOnly"
                                                :filled="formValues.readOnly"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                    <hr />
                                </v-container>
                            </v-card-text>

                            <v-card-actions v-if="this.editedItem.status === 'PENDING'">
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="validate"
                                >Submit</v-btn>
                            </v-card-actions>
                            <v-card-actions v-else>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import alertEventBus from "@/eventBus/AlertEventBus";
const FileDownload = () => import("@/fileHandler/components/FileDownload");
const responsiveButton = () => import("@/components/common/mobile/Button");
import {APPROVAL_STATUS} from "@/shared/enums/Approval";
import { mapGetters } from 'vuex';

const filterValues = [
    {name: "Select a status", value: "none"},
    { name: "Pending", value: "PENDING" },
    { name: "Approved", value: "APPROVED" },
    { name: "Rejected", value: "REJECTED" }
];

export default {
    name: "ApprovalTable",
    components: { FileDownload, responsiveButton },
    data() {
        return {
            status: filterValues,
            documentsSelect: filterValues[0].value,
            reportsSelect: filterValues[0].value,
            reportsTable: {
                headers: [
                    {
                        text: "Uploaded By",
                        align: "left",
                        sortable: true,
                        value: "requestedByName",
                        filterable: false
                    },
                    {
                        text: "Created by",
                        align: "left",
                        sortable: true,
                        value: "createdByName",
                        filterable: false
                    },
                    {
                        text: "Belongs to",
                        align: "left",
                        sortable: true,
                        value: "belongsToName",
                        filterable: false
                    },
                    {
                        text: "Requested Date",
                        align: "left",
                        sortable: true,
                        value: "systemCreatedDateTime",
                        filterable: false
                    },
                    {
                        text: "Status",
                        align: "left",
                        value: "status"
                    },
                    {
                        text: "Document Type",
                        align: "center",
                        value: "documentFile.displayName",
                        filterable: false
                    },
                    {
                        text: "Document Name",
                        align: "left",
                        sortable: true,
                        divider: true,
                        width: "2%",
                        value: "documentFile.name",
                        filterable: false
                    },
                    {
                        text: "Review",
                        align: "center",
                        sortable: false,
                        value: "review",
                        width: "2%",
                        filterable: false
                    }
                ]
            },
            documentsTable: {
              headers: [
                {
                    text: "Uploaded By",
                    align: "left",
                    sortable: true,
                    value: "requestedByName",
                    filterable: false
                },
                {
                    text: "Belongs to",
                    align: "left",
                    sortable: true,
                    value: "belongsToName",
                    filterable: false
                },
                {
                    text: "Requested Date",
                    align: "left",
                    sortable: true,
                    value: "systemCreatedDateTime",
                    filterable: false
                },
                {
                    text: "Status",
                    align: "left",
                    value: "status"
                },
                {
                    text: "Document Type",
                    align: "left",
                    value: "documentFile.displayName",
                    filterable: false
                },
                {
                    text: "Document Name",
                    align: "left",
                    sortable: true,
                    divider: true,
                    width: "2%",
                    value: "documentFile.name",
                    filterable: false
                },
                {
                    text: "Review",
                    align: "center",
                    sortable: false,
                    value: "review",
                    width: "2%",
                    filterable: false
                }
              ]
            },
            dialog: false,
            loading: false,
            editedItem: {
                documentFile: {
                    name: ""
                },
                reviewByUserId: ""
            },
            editedIndex: -1,
            formValues: {
                approved: null,
                comment: "",
                readOnly: false
            },
            valid: true,
            totalDocumentItems: 10,
            totalReportItems: 10,
            documentPagination: {},
            reportPagination: {},
            pageKeyCache: new Map(),
            keyId: ''
        };
    },
    methods: {
        initialize() {
            this.getDocumentApprovals();
        },
        async refreshDocumentApprovals() {
            this.loading = true;
            try {
                let params = this.getDocumentPaginationValues();
                if (this.documentsSelect) {
                  params['status'] = this.documentsSelect;
                }

                await this.$store.dispatch("getDocumentApprovals", params);
                this.setDocumentPaginationValues(this.documentApprovals);
            } catch (e) {
                alertEventBus.setAlert({ type: "error", msg: e.message });
            }
            this.loading = false;
        },
        async refreshReportApprovals() {
            this.loading = true;
            try {
                let params = this.getReportPaginationValues();
                if (this.reportsSelect) {
                  params['status'] = this.reportsSelect;
                }

                await this.$store.dispatch("getReportApprovals", params);
                this.setReportPaginationValues(this.reportApprovals);
            } catch (e) {
                alertEventBus.setAlert({ type: "error", msg: e.message });
            }
            this.loading = false;
        },
        async getDocumentApprovals() {
            if (this.documentApprovals.length <= 0) {
                await this.refreshDocumentApprovals();
            }
        },
        async getReportApprovals() {
            if (this.reportApprovals.length <= 0) {
                await this.refreshReportApprovals();
            }
        },

        async updateApproval() {
          try {
            await this.$store.dispatch("setApproval", this.editedItem);
          } catch (e) {
            alertEventBus.setAlert({ type: "error", msg: e.message });
          }
        },
        editApproval(approval) {
            if (approval.type.toLowerCase() === 'document') {
                this.editedIndex = this.documentApprovals.indexOf(approval);
            } else {
                this.editedIndex = this.reportApprovals.indexOf(approval);
            }

            this.editedItem = Object.assign({}, approval);

            if (this.editedItem.status !== "PENDING") {
                this.formValues.approved =
                    this.editedItem.status === "APPROVED";
                this.formValues.comment = this.editedItem.comment;
                this.formValues.readOnly = true;
            }
            this.dialog = true;
        },
        close() {
            this.$refs.form.reset();
            this.dialog = false;
            this.formValues = {
                approved: null,
                comment: "",
                readOnly: false
            };
        },
        async validate() {
            await this.$refs.form.validate();

            if (this.valid) {
                const user = this.$store.getters.getUser;
                this.editedItem.approvedByUserId = user.attributes.sub;

                if (this.formValues.approved) {
                    this.editedItem = {
                        ...this.editedItem,
                        status: "APPROVED",
                        comment: "approved-no-comment"
                    };
                } else {
                    this.editedItem = {
                        ...this.editedItem,
                        status: "REJECTED",
                        comment: this.formValues.comment
                    };
                }

                await this.updateApproval();
                this.close();
            }
        },

        getDocumentPaginationValues() {
            //all values of pagination that can be used for backend
            const { page, itemsPerPage } = this.documentPagination;
            let params = {
                limit: itemsPerPage
            }

            if(this.pageKeyCache.has(`document:${page - 1}`) && page != 1){
                params.lastEvaluatedKey = this.pageKeyCache.get(`document:${page -1}`);
            }

            return params;
        },
        getReportPaginationValues() {
            //all values of pagination that can be used for backend
            const { page, itemsPerPage } = this.reportPagination;
            let params = {
                limit: itemsPerPage
            }

            if(this.pageKeyCache.has(`report:${page - 1}`) && page != 1){
                params.lastEvaluatedKey = this.pageKeyCache.get(`report:${page -1}`);
            }

            return params;
        },

        setDocumentPaginationValues(list) {
            let key = this.$store.getters.getDocumentApprovalsLastEvaluatedKey;
            const { page, itemsPerPage } = this.documentPagination;

            this.totalDocumentItems = itemsPerPage * (page - 1) + list.length;
            if(key != null) {
                this.pageKeyCache.set(`document:${page}`, key);
                this.totalDocumentItems+=1;
            }
        },

        setReportPaginationValues(list) {
            let key = this.$store.getters.getReportApprovalsLastEvaluatedKey;
            const { page, itemsPerPage } = this.reportPagination;

            this.totalReportItems = itemsPerPage * (page - 1) + list.length;
            if(key != null) {
                this.pageKeyCache.set(`report:${page}`, key);
                this.totalReportItems+=1;
            }
        }
    },
    computed: {
        ...mapGetters({
          documentApprovals: 'getDocumentApprovals',
          reportApprovals: 'getReportApprovals',
        }),
        APPROVAL_STATUS(){
            return APPROVAL_STATUS;
        },
    },
    async created() {
        this.initialize();
    },
    watch: {
        documentPagination: {
            async handler () {
                await this.refreshDocumentApprovals();
            },
            deep: true
        },
        reportPagination: {
            async handler () {
                await this.refreshReportApprovals();
            },
            deep: true
        },
        documentsSelect: {
           async handler() {
            await this.refreshDocumentApprovals();
          }
        },
        reportsSelect: {
          async handler() {
            await this.refreshReportApprovals();
          }
        }
    },
};
</script>

<style scoped>
.v-chip.white-span span {
    color: white !important;
}
</style>
